import { Component, Input, OnInit } from '@angular/core';
import { ExternalService } from 'src/app/services/external/external.service';
import { SettingsService } from 'src/app/services/settings/settings.service';

@Component({
  selector: 'app-currency-selector',
  templateUrl: './currency-selector.component.html',
  styleUrls: ['./currency-selector.component.scss']
})
export class CurrencySelectorComponent implements OnInit {

  selectedCurrency;
  availableCurrecies = ['USD'];
  @Input() dark = false;
  
  constructor(
    private externalService: ExternalService,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {    
    this.selectedCurrency = this.settingsService.getCurrency();
    console.log('selected currency', this.selectedCurrency);

    const availableCurrencies = this.settingsService.getAvailableCurrencies();

    if (!availableCurrencies.includes(this.selectedCurrency)) {
      this.settingsService.setDefaultCurrency('USD');
      this.selectedCurrency = this.settingsService.getCurrency();
    }

    this.externalService.getGeoInformation().subscribe(geo => {
      const localCurrencyCode = geo?.currency?.code;

      if (localCurrencyCode !== 'USD' && availableCurrencies.includes(localCurrencyCode)) {
        this.availableCurrecies.push(localCurrencyCode);
      }
    });  
  }

  getCcFromCr(currencyCode: string) {
    switch(currencyCode) {
      case 'NGN': return 'ng';
      case 'USD': return 'us';
      case 'CAD': return 'ca';
    }
  }

  currencyChanged($event) {
    console.log('currency changed to ', $event.value);
    this.settingsService.setDefaultCurrency($event.value);
    window.location.reload();
    // this.router.navigate(['./'], { relativeTo: this.route, skipLocationChange: true });
  }

}
